<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container">
      <el-row>
        <el-col :span="5" class="content-left">
          <div class="trade-container">
            <el-card class="trade-nav-panel">
              <div slot="header" class="clearfix">
                <span class="panel-header">配额管理</span>
              </div>

              <el-menu router default-active="/isp/quota-info">
                <el-menu-item index="/isp/quota-info">
                  <span slot="title">查看配额信息</span>
                </el-menu-item>
              </el-menu>
            </el-card>
          </div>
        </el-col>
        <el-col :span="19" class="content-right" v-loading="loading">
          <div class="search-row">
            <el-select v-model="queryParams.buCode" placeholder="BU" clearable filterable @change="buChange">
              <el-option :label="item.orgName.split('|')[0]" :value="item.orgCode" v-for="(item, index) in buList" :key="index"></el-option>
            </el-select>
            <el-select v-model="queryParams.regionCode" placeholder="Region" clearable filterable @change="regionChange">
              <el-option :label="item.orgName.split('|')[0]" :value="item.orgCode" v-for="(item, index) in regionList" :key="index"></el-option>
            </el-select>
            <el-select v-model="queryParams.m3Code" placeholder="M3" clearable filterable>
              <el-option :label="item.clientName" :value="item.employeeCode" v-for="(item, index) in m3List" :key="index"></el-option>
            </el-select>
            <el-button type="danger" @click="getQuotaInfo">搜索</el-button>
            <el-button class="btn-red-plain" @click="reset">重置</el-button>
            <el-button type="danger" style="float: right" @click="toQuotaAllocate">配额分配</el-button>
          </div>
          <div class="quota-info">
            <div class="quota-title">
              <div style="min-width: 135px">品牌</div>
              <div style="min-width: 135px">项目</div>
              <div style="min-width: 155px">渠道</div>
              <div>总额度</div>
              <div>已用额度</div>
              <div>冻结额度</div>
              <div>可用额度</div>
            </div>
            <div class="quota-content" v-for="(item, key) in quotaInfo" :key="key">
              <div class="quota-content-title">
                <div>
                  {{ key }}
                </div>
              </div>
              <div style="flex: 1">
                <div class="quota-content-program" v-for="(program, programKey) in item" :key="programKey">
                  <div class="quota-content-title">
                    <div>{{ programKey }}</div>
                  </div>
                  <div style="width: 85%">
                    <div class="quota-content-channel" v-for="(channel, channelKey) in program" :key="channelKey">
                      <div style="width: 155px">{{ channelKey }}</div>
                      <div>{{ channel[0].quotaTotal | thousandSymbol }}</div>
                      <div>{{ channel[0].quotaUsed | thousandSymbol }}</div>
                      <div>{{ channel[0].quotaBlocked | thousandSymbol }}</div>
                      <div>{{ (channel[0].quotaTotal - channel[0].quotaUsed - channel[0].quotaBlocked) | thousandSymbol }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ispApi from '@/api/isp'
import ContentHeader from "@/components/content-header"
import { mapGetters } from 'vuex'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      queryParams: {
        buCode: '',
        regionCode: '',
        m3Code: '',
        quotaLevel: ''
      },
      quotaInfo: [],
      buList: [],
      regionList: [],
      m3List: [],
      authMap: {
        '28063811': '01AAAB',
        '28062577': '01AHME',
        '28077456': '01AAHP',
        '28051023': 'all',
        '28070610': 'all',
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created () {
    this.getQuotaInfo()
    this.getQuotaOrg()
  },
  methods: {
    toQuotaAllocate () {
      this.$router.push({
        path: '/isp/quota-allocate'
      })
    },
    getQuotaInfo () {
      this.queryParams.quotaLevel = ''
      if (this.queryParams.buCode) {
        this.queryParams.quotaLevel = 'BU'
      }
      if (this.queryParams.regionCode) {
        this.queryParams.quotaLevel = 'REGION'
      }
      if (this.queryParams.m3Code) {
        this.queryParams.quotaLevel = 'M3'
      }
      ispApi.getQuotaInfo(this.queryParams).then(res => {
        if (res.data.resultCode === '0') {
          let list = res.data.resultData.ispTradeQuotaDTOList
          const brandInfo = list.sort((a, b) => b - a).reduce((pre, item) => {
            pre[item.brandName] = [...(pre[item.brandName] || []), item]
            return pre
          }, {})
          Object.keys(brandInfo).forEach((key, index) => {
            if (index === 0) {
              this.chechedIndex = key
            }
            brandInfo[key].sort((a, b) => {
              return b.programType - a.programType
            })
            const project = brandInfo[key].reduce((pre, item) => {
              pre[item.programTypeName] = [...(pre[item.programTypeName] || []), item]
              return pre
            }, {})
            Object.keys(project).forEach(projectKey => {
              project[projectKey].sort((a, b) => {
                if (a.ispChannelCode === 'Livehouse音乐酒吧' && b.ispChannelCode === 'Western西式') {
                  return -1
                }
              })
              project[projectKey] = project[projectKey].reduce((pre, item) => {
                pre[item.ispChannelName] = [...(pre[item.ispChannelName] || []), item]
                return pre
              }, {})
            })
            brandInfo[key] = project
          })

          this.quotaInfo = brandInfo
          console.log(brandInfo, 'info')
        }
      })
    },
    // 获取区域列表
    getQuotaOrg () {
      this.loading = true
      ispApi.getQuotaOrg(this.queryParams).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.buList = res.data.resultData.baseOrgDTOList
        }
      }).catch(() => { this.loading = false })
    },
    buChange () {
      this.queryParams.regionCode = ''
      this.queryParams.m3Code = ''
      this.regionList = []
      this.m3List = []
      if (!this.queryParams.buCode) {
        return
      }
      this.regionList = this.buList.find(item => {
        return item.orgCode === this.queryParams.buCode
      }).subOrgList
    },
    regionChange () {
      this.queryParams.m3Code = ''
      this.m3List = []
      if (!this.queryParams.regionCode) {
        return
      }
      this.m3List = this.regionList.find(item => {
        return item.orgCode === this.queryParams.regionCode
      }).m3List
    },
    reset () {
      this.queryParams = this.$options.data().queryParams
      this.getQuotaInfo()
      this.regionList = []
      this.m3List = []
    }
  }
}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url('../../assets/images/banner-menu.jpg') center no-repeat;
  background-size: cover;
}
.trade-nav-panel {
  width: 80%;
  //   min-height: 290px;
  margin: 0 auto;
  background: $base-white;
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
  }
  ::v-deep .el-menu {
    border-right: 0;
  }
  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}

// .content-wrapper {
//   min-height: calc(100vh - 320px) !important;

//   .content-left,
//   .content-right {
//     height: 100%;
//     box-sizing: border-box;
//     a {
//       text-decoration: none;
//       color: #000;
//     }
//   }
//   .content-left {
//     padding-right: $content-middle;
//   }
// }

.search-row {
  .el-input,
  .el-select {
    width: 180px;
    margin-right: 20px;
  }
}
.quota-info {
  margin-top: 20px;
  .quota-title {
    display: flex;
    & > div {
      // flex: 1;
      min-width: 131px;
      height: 50px;
      line-height: 50px;
      font-weight: 400;
      background-color: #e8e8e8;
      color: #000;
      text-align: center;
    }
  }
  .quota-content-title {
    min-width: 135px;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    position: relative;
    & > div {
      position: absolute;
      width: 100%;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .quota-content {
    line-height: 50px;
    text-align: center;
    background-color: #fff;
    display: flex;
    .quota-content-program {
      display: flex;
      & > div {
        border-right: 1px solid #ebeef5;
      }
      .quota-content-channel {
        display: flex;
        & > div {
          border-right: 1px solid #ebeef5;
          border-bottom: 1px solid #ebeef5;
          width: 130px;
          // flex: 1;
        }
      }
    }
  }
}
</style>